import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ImbpAvailableSlots } from "./imbpAvailableSlots"
import { IAvailableSlots } from "./imbpAvailableSlots.types"

interface ISlotRaw {
  id: string
  startTime: string
  endTime: string
  "time-slot"?: string
}

interface IDayRaw {
  date: string
  slots: ISlotRaw[]
  provisional: boolean
}

export interface IAvailableSlotsRaw {
  days: IDayRaw[]
  booking_type?: boolean
}

export const ImbpAvailableSlotsParser: IParser<
  IAvailableSlots,
  IAvailableSlotsRaw
> = {
  toDomain: (data: IAvailableSlotsRaw) => {
    try {
      return new ImbpAvailableSlots({ days: data.days })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
